export class ProvisioningConstants {
    public static readonly ERROR_HEADER_TEXT = 'ERROR'
    public static readonly LOGOUT_BUTTON_TEXT = 'Retry authentication'
    public static readonly RETRY_BUTTON_TEXT = 'Retry'
    public static readonly PROVISIONING_ERROR_INSTRUCTION = 'Click one of the buttons below to retry. If the problem persists,' +
        ' please contact jihm-atm team for assistance'
}
